export default "__VITE_ASSET__DFQSLZh9__"